<template>
  <div class="recommend">
    <el-tabs v-model="activeName"
             @tab-click="handleClick"
             class="tabs">
      <el-tab-pane label="待推荐记录"
                   name="1"></el-tab-pane>
      <el-tab-pane label="已推荐记录"
                   name="2"></el-tab-pane>
    </el-tabs>
    <div class="recommend_search">
      <div class="search_list">
        <span>物流公司</span>
        <el-input v-model="companyName"
                  size="small"
                  placeholder="请输入物流公司"></el-input>
      </div>
      <div class="search_list">
        <span>司机姓名</span>
        <el-input v-model="driverName"
                  size="small"
                  placeholder="请输入司机姓名"></el-input>
      </div>
      <div class="search_list">
        <span>车头号</span>
        <el-input v-model="headNumber"
                  size="small"
                  placeholder="请输入公司名称"></el-input>
      </div>
      <div class="search_list">
        <span>车辆当前位置</span>
        <el-input v-model="addressName"
                  size="small"
                  placeholder="请输入公司名称"></el-input>
      </div>
      <div class="search_list"
           v-if="activeName === '2'">
        <span>推荐状态</span>
        <el-select v-model="schedule"
                   placeholder="请选择"
                   size="small">
          <el-option label="进行中"
                     value="01"></el-option>
          <el-option label="推荐完成"
                     value="02"></el-option>
          <el-option label="已取消"
                     value="03"></el-option>
        </el-select>
      </div>
      <el-button class="search-submit"
                 type="primary"
                 @click="handleSearchClick">查询</el-button>
    </div>
    <!-- 待推荐记录 -->
    <div class="proposed_table"
         v-if="activeName === '1'">
      <el-table :data="data.result"
                style="width: 100%"
                height="100%">
        <el-table-column class-name="number"
                         label="序号"
                         align="center"
                         type="index"
                         min-width="50"
                         fixed>

        </el-table-column>
        <el-table-column label="公司名称">
          <template slot-scope="scope">
            <div>{{scope.row.companyName}}</div>
          </template>
        </el-table-column>
        <el-table-column prop="equipmentId"
                         label="设备编码">
        </el-table-column>
        <el-table-column label="司机信息">
          <template slot-scope="scope">
            <div><span>姓名：</span>{{scope.row.dirverName}}</div>
            <div><span>手机号：</span>{{scope.row.dirverPhone}}</div>
          </template>
        </el-table-column>
        <el-table-column label="车辆信息">
          <template slot-scope="scope">
            <div v-if="scope.row.materialTank==='01'"><span>罐体：</span>铝罐</div>
            <div v-else-if="scope.row.materialTank==='02'"><span>罐体：</span>铁罐</div>
            <div v-else-if="scope.row.materialTank==='03'"><span>罐体：</span>白钢罐</div>
            <div v-else-if="scope.row.materialTank==='04'"><span>罐体：</span>铝合金罐</div>
            <div><span>车头号：</span>{{scope.row.headNumber }}</div>
            <div><span>备案介质：</span>{{scope.row.mediumClass}}</div>
            <div><span>核载量：</span>{{scope.row.nuclearLoadTonnage}}吨</div>
          </template>
        </el-table-column>
        <el-table-column label="车辆状态"
                         header-align="center"
                         align="center"
                         width="100">
          <template slot-scope="scope">
            <div v-if="scope.row.vehicleState==='01'">空车</div>
            <div v-else-if="scope.row.vehicleState==='02'">待运输</div>
            <div v-else-if="scope.row.vehicleState==='03'">重车</div>
          </template>
        </el-table-column>
        <el-table-column label="车辆当前位置">
          <template slot-scope="scope">
            <div>{{scope.row.addressName}}</div>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button @click="handleMatchClick(scope.row)">返程匹配</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 已推荐记录 -->
    <div class="recommened_table"
         v-else-if="activeName === '2'">
      <el-table :data="data.result"
                style="width: 100%"
                height="100%">
        <el-table-column class-name="number"
                         label="序号"
                         align="center"
                         type="index"
                         min-width="50"
                         fixed>
        </el-table-column>
        <el-table-column label="公司名称">
          <template slot-scope="scope">
            <div>{{scope.row.companyName}}</div>
          </template>
        </el-table-column>
        <el-table-column prop="equipmentId"
                         label="设备编码">
        </el-table-column>
        <el-table-column label="司机信息">
          <template slot-scope="scope">
            <div><span>姓名：</span>{{scope.row.driverName}}</div>
            <div><span>手机号：</span>{{scope.row.driverPhone}}</div>
          </template>
        </el-table-column>
        <el-table-column label="车辆信息">
          <template slot-scope="scope">
            <div v-if="scope.row.materialTank==='01'"><span>罐体：</span>铝罐</div>
            <div v-else-if="scope.row.materialTank==='02'"><span>罐体：</span>铁罐</div>
            <div v-else-if="scope.row.materialTank==='03'"><span>罐体：</span>白钢罐</div>
            <div v-else-if="scope.row.materialTank==='04'"><span>罐体：</span>铝合金罐</div>
            <div><span>车头号：</span>{{scope.row.headNumber }}</div>
            <div><span>备案介质：</span>{{scope.row.mediumClass}}</div>
            <div><span>核载量：</span>{{scope.row.nuclearLoadTonnage}}吨</div>
          </template>
        </el-table-column>
        <el-table-column label="车辆状态"
                         header-align="center"
                         align="center"
                         width="100">
          <template slot-scope="scope">
            <div v-if="scope.row.vehicleState==='01'">空车</div>
            <div v-else-if="scope.row.vehicleState==='02'">待运输</div>
            <div v-else-if="scope.row.vehicleState==='03'">重车</div>
          </template>
        </el-table-column>
        <el-table-column label="车辆当前位置">
          <template slot-scope="scope">
            <div>{{scope.row.vehiclePosition}}</div>
          </template>
        </el-table-column>
        <el-table-column label="推荐状态"
                         width="85">
          <template slot-scope="scope">
            <div v-if="scope.row.schedule==='01'">
              进行中
              <div class="inprogress">
                <span></span>
              </div>
            </div>
            <div v-else-if="scope.row.schedule==='02'">
              推荐完成
              <div class="complete"></div>
            </div>
            <div v-else-if="scope.row.schedule==='03'">
              已取消
              <div class="cancel"></div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="操作"
                         header-align="center"
                         align="center"
                         min-width="100">
          <template slot-scope="scope">
            <el-button @click="handleRecommendDetailClick(scope.row.routeReturnId)">查看详情</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页 -->
    <div class="pages">
      <span class="demonstartion"> 共{{data.total}}条记录</span>
      <el-pagination @current-change="handleCurrentChange"
                     :page-size="data.pageSize"
                     layout="prev, pager, next"
                     :total="data.total"
                     background>
      </el-pagination>
    </div>
  </div>
</template>

<script>
import {
  recommendList, // 已推荐记录
  proposedList // 待推荐记录

} from 'apis/index'
export default {
  name: 'Container',
  data () {
    return {
      inputname: '',
      activeName: '1',
      companyName: '', // 公司名称
      driverName: '', // 司机姓名
      headNumber: '', // 车头号
      addressName: '', // 车辆当前位置
      schedule: '', // 推荐状态
      pageNum: 1,
      data: {}
      // data: {
      //   total: 50,
      //   pageSize: 20,
      //   result: [
      //     {
      //       // 'dirverId': '8888', // 司机id
      //       // 'companyId': '8888', // 物流公司id
      //       // 'dirverName': '宋志1', // 司机姓名
      //       // 'dirverPhone': '15210404672', // 司机电话
      //       // 'lng': '116.3246154785', // 经度
      //       // 'lat': '39.8090635124', // 维度
      //       // 'headNumber': '陕F1234', // 车头号
      //       // 'tailNumber': '陕F2454', // 挂车号
      //       // 'nuclearLoadTonnage': 31, // 荷载吨数
      //       // 'mediumClass': '说的', // 介质类别
      //       // 'createDate': '2019-01-09 17:00:00', // 添加时间
      //       // 'equipmentId': '8888', // 设备唯一标识
      //       // 'vehicleState': '01', // 当前运输中车辆状态【01：空车 02:待运输 03:重车】
      //       // 'hardwareStatus': '01', // 硬件状态【01：正常 02：禁用】
      //       // 'hardwareSpecies': '1', // 硬件类别【1:智能硬件 2：手机】
      //       // 'dirverNum': '4545', // 设备对应的编码
      //       // 'materialTank': '01', // 罐体材质【 01：铝罐 02：铁罐 03：白钢罐 04：铝合金罐】
      //       // 'companyName': '银川化工', // 物流公司名称
      //       // 'addressName': '北京市通州区台湖镇通马路辅路东石公园', // 车辆目前所在位置
      //       // 'address': '包头市东河区工业路第二小学东门', // 公司注册所在地
      //       // 'supplyOfGoods': 'a6c44654-c084-4263-9260-f3e17e5de08d', // 返程推荐高级与专线货源
      //       // 'species': '2'// 返程推荐区分高级与专线货源【1：高级货源 2：专线货源】
      //     }
      //   ]
      // }
    }
  },
  mounted () {
    this.getProposedData()
  },
  methods: {
    getProposedData () { // 获取待推荐记录
      // recommendList().then(res => {
      //   if (res.data.code === 0) {
      //     console.log(res)
      //     this.data = res.data.data.pagination
      //   }
      // })
      // console.log('待推荐')
      proposedList({
        pageNum: this.pageNum,
        companyName: this.companyName,
        dirverName: this.driverName,
        headNumber: this.headNumber,
        addressName: this.addressName
      }).then(res => {
        this.data = res.data.data.pagination
      })
    },
    getRecommenedData () { // 获取已推荐记录
      // console.log('已推荐')
      recommendList({
        pageNum: this.pageNum,
        companyName: this.companyName,
        driverName: this.driverName,
        headNumber: this.headNumber,
        addressName: this.addressName,
        schedule: this.schedule
      }).then(res => {
        // console.log('yituijian', res)
        if (res.data.code === 0) {
          this.data = res.data.data
        }
      })
    },
    handleClick (tab, event) { // table
      this.companyName = ''
      this.driverName = ''
      this.headNumber = ''
      this.addressName = ''
      this.schedule = ''
      this.pageNum = 1
      if (this.activeName === '1') {
        this.data = {}
        this.getProposedData()
      } else if (this.activeName === '2') {
        this.data = {}
        this.getRecommenedData()
      }
    },
    handleSearchClick () { // 查询
      if (this.activeName === '1') { // 待推荐查询
        this.pageNum = 1
        this.getProposedData()
        // console.log(
        //   '待推荐查询',
        //   this.companyName,
        //   this.driverName,
        //   this.headNumber,
        //   this.addressName,
        //   this.schedule)
        // proposedList({
        //   companyName: this.companyName,
        //   dirverName: this.driverName,
        //   headNumber: this.headNumber,
        //   addressName: this.addressName
        // }).then(res => {
        //   if (res.data.code === 0) {
        //     this.data = res.data.data.pagination
        //   }
        // })
      } else if (this.activeName === '2') { // 已推荐查询
        this.pageNum = 1
        this.getRecommenedData()
        // console.log(
        //   '已推荐查询',
        //   this.companyName,
        //   this.driverName,
        //   this.headNumber,
        //   this.addressName,
        //   this.schedule)
        // recommendList({
        //   companyName: this.companyName,
        //   driverName: this.driverName,
        //   headNumber: this.headNumber,
        //   addressName: this.addressName,
        //   schedule: this.schedule
        // }).then(res => {
        //   if (res.data.code === 0) {
        //     this.data = res.data.data
        //   }
        // })
      }
    },
    handleRecommendDetailClick (item) { // 已推荐查看详情
      // console.log(item)
      this.$router.push({
        path: 'recommend/recommendRoute',
        query: {
          'item': item
        }
      })
    },
    handleCurrentChange (val) { // 切页切换
      this.pageNum = val
      //   let status = this.activeName
      if (this.activeName === '1') {
        this.getProposedData()
      } else if (this.activeName === '2') {
        this.getRecommenedData()
      }
    },
    handleMatchClick (item) { // 返程匹配
      // console.log(item)
      this.$router.push({
        path: 'recommend/proposedRoute',
        query: {
          'driverid': item.dirverId,
          'addressName': item.addressName,
          'supplyOfGoods': item.supplyOfGoods,
          'species': item.species
        }
      })
    }
  }
}
</script>
<style lang="stylus">
@import '~styles/mixins.styl'
@import '~styles/varibles.styl'
.recommend
  height 100%
  .tabs
    height 51px
    overflow hidden
    background #fff
    .el-tabs__nav-wrap::after
      height 1px
      bottom 1px
    .el-tabs__item
      padding 0
      text-align center
      height 51px
      line-height 50px
      width 92px
      size12()
      color #5e656f
      &:hover
        color #1b88ee
    .el-tabs__item.is-active
      border-bottom 2px solid #409EFF
      color #1b88ee
    .el-tabs__active-bar
      background transparent !important
  .recommend_search
    padding 0 20px
    padding-right 96px
    overflow hidden
    position relative
    color #5E656F
    .search_list
      margin 7px 0
      float left
      span
        float left
        line-height 32px
        width 80px
        text-align right
        margin-right 10px
      .el-input
        width 146px
    .search-submit
      padding 7px 24px
      background #fff
      font-size 12px
      text-align right
      position absolute
      right 20px
      top 8px
      color $bgColor
      &:hover
        background $bgColor
        color #fff
  .recommened_table
    height calc(100% - 160px)
    padding 0 20px
    width calc(100% - 40px)
  .proposed_table
    height calc(100% - 160px)
    padding 0 20px
    width calc(100% - 40px)
  .el-table
    .cell
      size12()
      color #5E656F
      span
        color #858C96
      .inprogress
        position relative
        width 62px
        height 6px
        background #CFD5DC
        border-radius 3px
        span
          position absolute
          top 0
          left 0
          width 40px
          bottom 0
          border-radius 3px
          background #00D5B9
          z-index 100
      .complete
        width 62px
        height 6px
        background #00D5B9
        border-radius 3px
      .cancel
        width 62px
        height 6px
        background url('../../../../assets/images/09/cancel.png') no-repeat center
      .el-button
        size12()
        margin-bottom 10px
        margin-left 10px
        width 78px
        height 28px
        padding 0
        background #1B88EE
        border 1px solid #1B88EE
        color #ffffff
        span
          color #fff
  .el-table th
    background #e7f0f8
    .cell
      height 25px
      line-height 25px
.el-pagination
  color #5e656f
  font-weight 100
.el-pagination.is-background .btn-next, .el-pagination.is-background .btn-prev, .el-pagination.is-background .el-pager li
  background transparent
  border 1px solid #cfd5dc
.pages
  margin-top 15px
  padding 0 20px
  .demonstartion
    float right
    line-height 45px
    color #5e656f
.el-table td, .el-table th
  vertical-align top
@media (max-width: 1229px)
  .proposed_table
    height calc(100% - 210px) !important
@media (max-width: 1465px)
  .recommened_table
    height calc(100% - 210px) !important
</style>
